// Maybe not the end of time, but far enough out for our purposes
const endOfTimeTicks = new Date(2999, 12, 31).getTime() * 1e4 + 621355968e9;

/**
 *
 * @param {*} header
 * @param {*} property
 * @param {string} displayDefault Default column displayValue if the client timestamp has no data.
 * @param {boolean} useDateDisplay Use DateDisplay for the displayValue instead of Display
 * @param {boolean} sortNullAsEndOfTime If true, sorts a client timestamp with no data as if it were the 'end of time'.
 *
 * Return an object that represents a column suitable for displaying a
 * ClientTimestamp within a column in a pc-table, including handling
 * pitfalls of improper sort, search, and display
 */
export function getClientTimestampTableColumn(header, property, displayDefault, useDateDisplay, sortNullAsEndOfTime) {
    return {
        header,
        property,
        data: property, // Used for server-side paginiation
        orderable: true,
        searchable: true,
        visible: true,
        sortValue: function (rowItem) {
            const clientTs = rowItem && rowItem[property];
            let sv = (clientTs && clientTs.Ticks) || 0;
            if (sv === 0 && sortNullAsEndOfTime) {
                sv = endOfTimeTicks;
            }
            return sv;
        },
        searchValue: function (rowItem) {
            const clientTs = rowItem && rowItem[property];
            return (clientTs && clientTs.Display) || "";
        },
        displayValue: function (clientTs) {
            return (clientTs && (useDateDisplay ? clientTs.DateDisplay : clientTs.Display)) || displayDefault || "";
        }
    };
}

/**
 * see
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toTimeString
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat
 * for more info on the date locale methods.
 */
export function hourToLocalizedTimeString({ hour, locale }) {
    const timeObj = new Date(2000, 0, 1, hour ?? 0);
    const timeStr = timeObj.toLocaleTimeString(locale, { hourCycle: "h23", hour: "2-digit", minute: "2-digit" });
    return timeStr;
}
/**
 * see
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toTimeString
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat
 * for more info on the date locale methods.
 */
export function monthAndDayToLocalizedDateString({ month, day, locale }) {
    const monthIndex = (month ?? 1) - 1; // for some reason the date constructor expects months to be 0 indexed
    const date = new Date(2000, monthIndex, day ?? 1);
    const dayOfYearStr = date.toLocaleDateString(locale, { month: "long", day: "numeric" });
    return dayOfYearStr;
}
